import React from 'react'
import { LibrariesTabType } from '../../helpers/ui-interfaces'

export type ActiveGridContextType = {
  activeGrid: LibrariesTabType | null
  setActiveGrid: (grid: LibrariesTabType | null) => void
  initLoadRef: React.MutableRefObject<boolean>
}

export const ActiveGridContext = React.createContext<ActiveGridContextType>({
  activeGrid: null,
  setActiveGrid: () => null,
  initLoadRef: { current: false }
})

/** Saves the active grid state */
export const ActiveGridProvider = ({ children }: React.PropsWithChildren) => {
  const initLoadRef = React.useRef(false)
  const [activeGrid, setActiveGrid] =
    React.useState<ActiveGridContextType['activeGrid']>(null)

  return (
    <ActiveGridContext.Provider
      value={{
        initLoadRef,
        activeGrid,
        setActiveGrid
      }}
    >
      {children}
    </ActiveGridContext.Provider>
  )
}

export const useActiveGridContext = () => React.useContext(ActiveGridContext)
